export enum InsuranceStatus {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    SELF_PAYMENT = 'SELF_PAYMENT',
    OTHER = 'OTHER',
}
